import React from 'react';
// import { PlansContainer } from './style';
import { Card } from './WorkoutCard';

export const Plans = ({ plannedWorkouts }) => {
    return (
        <div>
            {plannedWorkouts.map((workout, index) => (
                <Card hasLink={true} {...workout} key={index} />
            ))}
        </div>
    );
};

export const SelectablePlans = ({ plannedWorkouts, onClick }) => {
    return (
        <div>
            {plannedWorkouts.map((workout, index) => (
                <div style={{ cursor: 'pointer' }} onClick={() => onClick(workout.id)}>
                    <Card hasLink={false} {...workout} key={index} />
                </div>
            ))}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Containers/PlannedWorkouts/Plans.js